import { inject, Service } from '@angular/core';
import { BaseMessageService, MESSAGE_SERVICE_TOKEN } from '@services/messages';

@Service()
export class ErrorMessageService {
  private readonly messageService = inject<BaseMessageService>(MESSAGE_SERVICE_TOKEN);

  showError(messageKey: string): void {
    this.messageService.showErrorMessage(messageKey);
  }

  showValidationError(messageKey: string): void {
    this.messageService.showErrorMessage(messageKey);
  }

  showGlobalError(): void {
    this.messageService.showErrorMessage('errors.unexpectedError');
  }

  showForbiddenError(): void {
    this.messageService.showErrorMessage('errors.forbidden');
  }
}
